import React, { useState } from "react";
import { toast } from "react-toastify";

import { ApiService } from "../ApiService";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Button,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const list_categorias = [
  '9131895281',
  '17135212292125',
  '9795155',
  '52941',
  '6939151',
  '520201139515221',
  '192391817051253222017159317',
  '112234',
  '2313915921222017023221713172220921',
  '5181201391715',
  '5723209414',
  '235212521',
  '2452122913515221',
  '1722201721'
];

export const ModalGastos = ({ onClose, updated_list, key_branch, convertPrice = (() => { }) }) => {
  const [codigo, setCodigo] = useState(null);
  const [nombre, setNombre] = useState("");
  const [precioUnidad, setPrecioUnidad] = useState(0);
  const [cantidad, setCantidad] = useState(0);
  const [descuento, setDescuento] = useState(0);
  const [formaPago, setFormaPago] = useState("");

  const [rows, setRows] = useState([]); // Arreglo dinámico para almacenar productos

  const subtotal = parseFloat(precioUnidad || 0.00) * Number(cantidad || 0);
  const total = Math.max(subtotal - descuento, 0);

  const handleAgregar = () => {
    if (codigo == null || !nombre || precioUnidad <= 0 || cantidad <= 0 || !formaPago) {
      toast.error("Complete todos los campos requeridos.", { position: "top-right" });
      return;
    }

    const newRow = {
      codigo,
      detalle: nombre,
      pUni: parseFloat(precioUnidad).toFixed(2),
      can: Number(cantidad),
      desc: parseFloat(descuento).toFixed(2),
      fpayment: formaPago,
      total: total.toFixed(2)
    };

    setRows([...rows, newRow]); // Añadir fila a la tabla

    // Limpiar campos
    setCodigo("");
    setNombre("");
    setPrecioUnidad(0);
    setCantidad(0);
    setDescuento(0);
    setFormaPago(""); // Limpiar selección del radio-button
  };

  const handleDeleteRow = (index) => {
    const newRows = [...rows];
    newRows.splice(index, 1);
    setRows(newRows);
  };

  async function savePurchase(element) {
    if (rows.length > 0) {
      const obj_purchase = rows.map((data) => ({
        product: data.detalle,
        quantity: data.can,
        discount: parseFloat(data.desc).toFixed(2),
        price: parseFloat(data.pUni).toFixed(2),
        tpay: String(data.fpayment).toLowerCase(),
        type: list_categorias[parseInt(data.codigo)],
      }));

      const url = `api/company/expense/insert?key_branch=${key_branch}`;

      const options = {
        method: 'POST',
        body: JSON.stringify({ data: obj_purchase }),
      };

      const fetch_request = await ApiService.fetchData(url, options);

      if (fetch_request.code && fetch_request.code == 200) {
        toast.success(fetch_request.message);
        updated_list();
        onClose();
        return;
      }

      toast.error(fetch_request.message || "Error en la solicitud");
    } else {
      toast.error("No es posible ingresar una compra vacía.", { position: "top-right" });
    }

    element.disabled = false;
    element.style.opacity = 1;
    element.innerText = "Guardar";
  }

  return (
    <div className="modal-overlay-caja">
      <div className="modal-container-caja">
        {/* Cabecera del modal */}
        <div className="modal-header-old">
          <h2 className="modal-title">Gastos y otros</h2>
          <button className="close-modal-btn-caja" onClick={onClose}>
            ✖
          </button>
        </div>

        {/* Formulario principal */}
        <div className="modal-body-caja">
          <div className="form-row-caja">
            <div className="form-group" style={{ width: "50%" }}>
              <label>
                Uso del producto: <span style={{ color: "red" }}>*</span>
              </label>
              <select value={codigo || 0} onChange={(e) => setCodigo(e.target.value)} className="modal-input-old">
                <option value='0'>Limpieza</option>
                <option value='1'>Comestible</option>
                <option value='2'>Higiene</option>
                <option value='3'>Bebida</option>
                <option value='4'>Oficina</option>
                <option value='5'>Herramienta</option>
                <option value='6'>Equipo electronico</option>
                <option value='7'>Salud</option>
                <option value='8'>Suministro Automotris</option>
                <option value='9'>Reparacion</option>
                <option value='10'>Seguridad</option>
                <option value='11'>Muebles</option>
                <option value='12'>vestimenta</option>
                <option value='13'>Otro</option>
              </select>
            </div>
            <div className="form-group" style={{ width: "50%" }}>
              <label>
                Nombre del producto: <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
                className="modal-input-old"
              />
            </div>
          </div>

          <div className="form-row-caja">
            <div className="form-group" style={{ width: "50%" }}>
              <label>
                Precio Unidad: <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="number"
                value={precioUnidad}
                step={0.1}
                min={0.1}
                onChange={(e) => setPrecioUnidad(e.target.value)}
                className="modal-input-old"
              />
            </div>
            <div className="form-group" style={{ width: "50%" }}>
              <label>
                Cantidad: <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="number"
                value={cantidad}
                step={1}
                min={1}
                onChange={(e) => setCantidad(e.target.value)}
                className="modal-input-old"
              />
            </div>
          </div>

          <div className="form-row-caja">
            <div className="form-group" style={{ width: "50%" }}>
              <label>Descuento:</label>
              <input
                type="number"
                value={descuento}
                step={0.10}
                min={0}
                onChange={(e) => setDescuento(e.target.value)}
                className="modal-input-old"
              />
            </div>

            {/* Opciones de forma de pago */}
            <div className="form-group total-payment-caja" style={{ display: "flex", flexDirection: "column", width: "50%" }}>
              <div className="form-group pay-title">
                <div>
                  <span>
                    Forma de pago <span style={{ color: "red" }}>*</span>
                  </span>
                </div>
              </div>
              <div className="payment-options-caja">
                <label className="payment-option-caja">
                  <input
                    type="radio"
                    name="formaPago"
                    value="Efectivo"
                    checked={formaPago === "Efectivo"} // Sincronizar con el estado
                    onChange={(e) => setFormaPago(e.target.value)}
                  />
                  <span>Efectivo</span>
                </label>
                <label className="payment-option-caja">
                  <input
                    type="radio"
                    name="formaPago"
                    value="QR"
                    checked={formaPago === "QR"} // Sincronizar con el estado
                    onChange={(e) => setFormaPago(e.target.value)}
                  />
                  <span>QR</span>
                </label>
                <label className="payment-option-caja">
                  <input
                    type="radio"
                    name="formaPago"
                    value="en espera"
                    checked={formaPago === "en espera"} // Sincronizar con el estado
                    onChange={(e) => setFormaPago(e.target.value)}
                  />
                  <span>Por pagar</span>
                </label>
              </div>
            </div>
          </div>

          {/* Botón Agregar */}
          <div className="form-group">
            <Button
              variant="contained"
              color="success"
              onClick={handleAgregar}
              fullWidth
              style={{ fontWeight: "bold" }}
            >
              Agregar
            </Button>
          </div>
        </div>

        {/* Tabla de detalles de compra */}
        <div style={{ marginBottom: "20px" }}>
          <TableContainer component={Paper} sx={{ marginTop: 2 }}>
            <Table sx={{ minWidth: 650 }} aria-label="tabla de compra">
              <TableHead>
                <TableRow sx={{ backgroundColor: "#007bff" }}>
                  <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>CODIGO</TableCell>
                  <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>DETALLE</TableCell>
                  <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>P. UNID</TableCell>
                  <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>CAN</TableCell>
                  <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>DESC.</TableCell>
                  <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>TOTAL</TableCell>
                  <TableCell sx={{ color: "#fff", fontWeight: "bold" }}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      No hay productos
                    </TableCell>
                  </TableRow>
                ) : (
                  rows.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>{row.codigo}</TableCell>
                      <TableCell>{row.detalle}</TableCell>
                      <TableCell>{convertPrice(row.pUni)}</TableCell>
                      <TableCell>{row.can}</TableCell>
                      <TableCell>{convertPrice(row.desc)}</TableCell>
                      <TableCell>{convertPrice(row.total)}</TableCell>
                      <TableCell>
                        <IconButton
                          color="error"
                          onClick={() => handleDeleteRow(index)}
                          aria-label="delete row"
                          title="Eliminar"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>

        {/* Footer de botones */}
        <div className="modal-footer">
          <button type="button" className="cancel-button-product" onClick={onClose}>
            Cancelar
          </button>
          <button type="submit" className="save-button" onClick={(e) => {
            e.target.disabled = true;
            e.target.style.opacity = 0.4;
            e.target.innerText = "registrando...";

            savePurchase(e.target);
          }}>
            Guardar
          </button>
        </div>
      </div>
    </div>
  );
};
